import { DocumentNode, gql } from '@apollo/client';
import { DatabasesDisplayGridRowDataFragmentGql } from './DatabasesDisplayGridRowFragmentGql';

export const DatabasesByTagQueryGql: DocumentNode = gql`
query DatabasesByTag(
  $tagName: String!,
  $first: Int!,
  $offset: Int!,
  $textSearch: String,
  $orderBy: DatabaseSortOrder!,
  $hasActiveWarning: Boolean,
  $isCertified: Boolean,
  
  ) {
  tags(filter: {name: $tagName}) {
    databasesConnection(
      first: $first,
      offset: $offset,
      orderBy: $orderBy,
      filter: {
        hasActiveWarning: $hasActiveWarning,
        isCertified: $isCertified,
        text: $textSearch
      },
      permissionMode: FILTER_RESULTS
    ) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: databasesConnection(
      filter: {
        hasActiveWarning: $hasActiveWarning,
        isCertified: $isCertified,
        text: $textSearch
      }
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1,
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: databasesConnection(
      filter: {
        hasActiveWarning: $hasActiveWarning,
        isCertified: $isCertified,
        text: $textSearch
      }
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1,
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${DatabasesDisplayGridRowDataFragmentGql}
`;
